import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    return false;
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/access',
      name: 'access',
      component: () => import('../views/Access.vue'),
    },
  ],
});

// Silently drop query params from the home page URL without a redirect,
// so no secondary router navigation fires and scroll position is preserved.
router.beforeEach((to, _from, next) => {
  if (to.name === 'home' && Object.keys(to.query).length > 0) {
    window.history.replaceState(null, '', to.path);
  }
  next();
});

export default router;
